export default {
  state: { wrapUpCodes: [], queueWrapUpCodes: [], loaded: false },
  actions: { fetchWrapUpCodes: () => void 0 },
};
